import { FC } from 'react'
import './AdminMobileHeader.scss'
import logo from '../../../Assets/Images/logo-white.svg'
import { Link } from 'react-router-dom'
import message from '../../../Assets/Images/message.png'
import bell from '../../../Assets/Images/bell.png'

interface propsType {
  publicAccess?: boolean
  onMenuClick?: () => void
}
const AdminMobileHeader: FC<propsType> = ({ publicAccess, onMenuClick }) => {
  return (
    <header className='admin-mobile-header'>
      <div className='container h-100 px-4'>
        <div className='row h-100'>
          {!publicAccess && (
            <div className='col-2 my-auto'>
              <button
                className='btn d-flex justify-content align-item-center'
                type='button'
                aria-label='Open navigation menu'
                onClick={onMenuClick}
              >
                <i className='d-icon d-menu-hamburger' aria-hidden='true'></i>
              </button>
            </div>
          )}
          <div className={!publicAccess ? 'col-5 my-auto' : 'col-12 text-center my-auto'}>
            <Link className='navbar-brand' to='/'>
              <img src={logo} className='logo mb-1' />
            </Link>
          </div>

          {!publicAccess && (
            <div className='col-5 px-0 my-auto'>
              <ul className='nav float-end'>
                <li className='nav-item'>
                  <a href='' className='nav-link'>
                    <img src={message} className='notice-icon'></img>
                  </a>
                </li>

                <li className='nav-item'>
                  <a href='' className='nav-link'>
                    <img src={bell} className='notice-icon'></img>
                  </a>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </header>
  )
}

export default AdminMobileHeader
